export default "/images/candy-image-90.png?7191c47c4ffd9b4275267da382f4a3c3";